export function BinxMark(props: React.ComponentProps<"div">) {
  return (
    <div
      className="font-doto text-4xl font-extrabold tracking-tighter text-foreground"
      style={{ fontWeight: 800 }}
      {...props}
    >
      BinX
    </div>
  );
}
